import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { PrimaryButton } from '../ui/PrimaryButton';
import { GhostButton } from '../ui/GhostButton';
import { Input } from '../ui/Input';
import { useToast } from '../../context/ToastContext';

export const ReindexModal = ({ isOpen, onClose, document, onReindex }) => {
    const { toast } = useToast();
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!document) return null;

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const response = await fetch('/api/admin/rag/reindex', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    document_id: document.id,
                    embedding_model: 'nomic-embed-text',
                    chunker: 'chars:1000:overlap:200',
                    reason: reason
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Re-index failed");
            } else {
                toast.success("Index rebuild started!");
                onReindex && onReindex(data.job_id);
                onClose();
            }

        } catch (error) {
            console.error("Re-index error:", error);
            toast.error(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Rebuild RAG Index" maxWidth="max-w-lg">
            <div className="space-y-4">
                <div className="bg-amber-500/10 border border-amber-500/20 p-4 rounded-lg">
                    <p className="text-sm text-amber-200">
                        <strong>Warning:</strong> You are about to rebuild the index for <strong>{document.name}</strong>.
                        <br /><br />
                        This will <strong>delete all existing embeddings</strong> for this document and queue a fresh ingestion using the active pipeline.
                    </p>
                </div>

                <div>
                    <label className="block text-xs font-semibold text-stone-400 uppercase mb-1">Reason / Notes</label>
                    <textarea
                        className="w-full bg-stone-950 border border-stone-800 rounded-lg px-3 py-2 text-sm text-stone-200 focus:outline-none focus:border-blue-500 h-20 resize-none"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Why are you rebuilding this index? (Optional)"
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-stone-700">
                    <GhostButton onClick={onClose}>Cancel</GhostButton>
                    <PrimaryButton onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? "Starting..." : "Confirm Rebuild"}
                    </PrimaryButton>
                </div>
            </div>
        </Modal>
    );
};
